export enum AutoCompleteType {
    Email,
    PhoneNumber,
    Id
}